import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IPaymentWalletResponse } from "@/api_framework/api_modals/payment";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setWalletDetails } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentUserWalletAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async (userId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerWalletDetailsInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.USER_WALLET?.baseURL}${userId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentWalletResponse>) => {
            if (res.data.status === true) {
              dispatch(setWalletDetails(res.data.data));
              dispatch(
                setLoading({
                  key: "isCustomerWalletDetailsInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              dispatch(setWalletDetails(null));
              dispatch(
                setLoading({
                  key: "isCustomerWalletDetailsInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setWalletDetails(null));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerWalletDetailsInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(setWalletDetails(null));
        dispatch(
          setLoading({
            key: "isCustomerWalletDetailsInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
